import React from 'react';

export const buttonTypes = {
    primary: 'primary',
    secondary: 'secondary',
    icon: 'icon',
    link: 'link',
    toggle: 'toggle',
};

const Button = ({ children, type, className, ...rest }) => {
    if (type === 'link')
        return (
            <button
                {...rest}
                className="flex items-center gap-4 transition-all text-brand-dark hover:text-button-hover active:text-button-pressed disabled:text-grey-normal font-PoppinsMedium tracking-wide px-4 py-3"
            >
                {children}
            </button>
        );

    if (type === 'icon')
        return (
            <button
                {...rest}
                className="flex items-center transition-all text-brand-dark font-poppins px-5 py-3 bg-brand-light disabled:bg-grey-light border border-brand-light rounded-xl "
            >
                {children}
            </button>
        );

    if (type === 'secondary')
        return (
            <button
                {...rest}
                className="flex items-center gap-4 transition-all text-brand-dark hover:text-button-hover active:text-button-pressed disabled:text-grey-normal font-PoppinsMedium tracking-wide px-4 py-2 bg-white border-2 border-brand-main hover:border-button-hover active:border-button-pressed disabled:border-grey-normal rounded-xl "
            >
                {children}
            </button>
        );

    if (type === 'primary')
        return (
            <button
                {...rest}
                type="submit"
                className="flex items-center gap-4 transition-all text-white font-PoppinsMedium tracking-wide px-4 py-2 bg-brand-dark hover:bg-button-hover active:bg-button-pressed disabled:bg-grey-normal border-2 border-brand-dark hover:border-button-hover active:border-button-pressed disabled:border-grey-normal rounded-xl "
            >
                {children}
            </button>
        );

    if (type === 'submit')
        return (
            <button
                {...rest}
                type="submit"
                className="flex items-center gap-4 transition-all text-white font-PoppinsMedium tracking-wide px-4 py-2 bg-brand-dark hover:bg-button-hover active:bg-button-pressed disabled:bg-grey-normal border-2 border-brand-dark hover:border-button-hover active:border-button-pressed disabled:border-grey-normal rounded-xl "
            >
                {children}
            </button>
        );

    if (type === 'toggle')
        return (
            <button
                {...rest}
                className={`flex items-center gap-4 transition-all text-white font-PoppinsMedium tracking-wide px-4 py-1 bg-brand-dark hover:bg-button-hover hover:border-button-hover active:bg-button-pressed rounded-xl disabled:bg-grey-normal cursor-pointer ${className}`}
            >
                {children}
            </button>
        );

    if (type === 'delete')
        return (
            <button
                {...rest}
                className="flex items-center gap-4 transition-all text-error disabled:text-grey-normal font-PoppinsMedium tracking-wide px-4 py-3"
            >
                {children}
            </button>
        );

    if (type === 'button')
        return (
            <button
                {...rest}
                type="button"
                className="flex items-center gap-4 transition-all text-grey-dark hover:text-grey-normal active:text-black disabled:text-grey-normal font-PoppinsMedium tracking-wide px-4 py-2 bg-white disabled:bg-grey-light border border-grey-light rounded-xl "
            >
                {children}
            </button>
        );

    return (
        <button
            {...rest}
            className="flex items-center gap-4 transition-all text-grey-dark hover:text-grey-normal active:text-black disabled:text-grey-normal font-PoppinsMedium tracking-wide px-4 py-2 bg-white disabled:bg-grey-light border border-grey-light rounded-xl "
        >
            {children}
        </button>
    );
};

export default Button;
